import TableRow from "components/rows/tableRow";
import Radio from "components/rows/radio";
import Select from "components/select";
import { lastTimes } from "components/utils/option";
import { useTranslation } from "react-i18next";
import { useOptionFilterContext } from "../context";
import { SEARCH_FORM_ID_ROOM_OPTION } from "components/constent";
import { useSubmit } from "./handler";

type IProps = {};

const SearchForm = () => {
  const { t } = useTranslation();
  const { filters, onChange, onSelect, onReset } = useOptionFilterContext();

  // 페이지 번호 클릭 시 새로운 데이터 가져오기
  const { onSubmit } = useSubmit();
  return (
    <>
      <form
        id={SEARCH_FORM_ID_ROOM_OPTION}
        onSubmit={onSubmit}
        onReset={onReset}
      >
        <table>
          <tbody>
            {/* <LodInfRow /> */}

            <TableRow title={t("row_ttl_rm_op_inf")}>
              <ul>
                <li>
                  <label htmlFor="">{t("lbl_lat_out_ti")}</label>
                  <Select
                    name={"latChkOutTi"}
                    styles="bg-white border-1"
                    options={lastTimes}
                    isReset={!filters?.latChkOutTi}
                    onSelect={(option) =>
                      onSelect("latChkOutTi", option.code.replaceAll(":", ""))
                    }
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_bed_typ")}</label>
                  <div className="flex">
                    <Radio
                      label={t("included_y")}
                      id={"Y"}
                      name={"brkfInYn-S"}
                      checked={filters?.brkfInYn === "Y"}
                      onChange={(e) => onChange("brkfInYn", "Y")}
                    />
                    <Radio
                      label={t("included_n")}
                      id={"N"}
                      name={"brkfInYn-S"}
                      checked={filters?.brkfInYn === "N"}
                      onChange={(e) => onChange("brkfInYn", "N")}
                    />
                  </div>
                </li>

                <li>
                  <label htmlFor="">{t("lbl_status_cmm")}</label>
                  <div className="flex">
                    <Radio
                      label={t("uyn_y")}
                      id={"Y"}
                      name={"uyn-op-S"}
                      checked={filters?.uyn === "Y"}
                      onChange={(e) => onChange("uyn", "Y")}
                    />
                    <Radio
                      label={t("uyn_n")}
                      id={"N"}
                      name={"uyn-op-S"}
                      checked={filters?.uyn === "N"}
                      onChange={(e) => onChange("uyn", "N")}
                    />
                  </div>
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      </form>
    </>
  );
};

export default SearchForm;

// export default forwardRef<HTMLFormElement, IProps>(SearchForm);
